import type { Dictionary } from '../models'

export function compileMessage(message: string, params: Dictionary<string>): string {
  return Object.entries<string>(params).reduce(
    (compiledMessage: string, [key, value]) =>
      compiledMessage.replace(new RegExp(`{${key}}`, 'g'), value),
    message,
  )
}

export const buildMessagesWithSeparator = (
  items: Array<string>,
  separator: string,
  lastSeparator?: string,
  withStrong?: boolean,
): string => {
  let uniqueItems = [...new Set(items).values()]

  if (withStrong) {
    uniqueItems = uniqueItems.map(item => `<strong>${item}</strong>`)
  }

  let texts = uniqueItems.join(separator)
  if (lastSeparator) {
    texts = texts.replace(new RegExp(`,(?=[^${separator.trim()}]+$)`), ` ${lastSeparator}`)
  }

  return texts
}
